(() => {
  let dialog, modalSource, modalClose, previousOverflow;
  const isMobile = () => window.matchMedia('(max-width: 700px), (pointer: coarse)').matches;
  function getDialog() {
    if (dialog) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'cm-phone-dialog';
    dialog.setAttribute('aria-label', 'Full app screen');
    dialog.innerHTML = '<div class="cm-phone-dialog-bar"><span>App preview</span><button type="button" aria-label="Close app preview">✕</button></div><div class="cm-phone-dialog-content"></div>';
    document.body.append(dialog);
    dialog.querySelector('button').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      const rect = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
    });
    dialog.addEventListener('close', () => {
      document.body.style.overflow = previousOverflow;
      const source = modalSource, close = modalClose;
      modalSource = modalClose = null;
      close?.();
      source?.focus({ preventScroll: true });
    });
    return dialog;
  }
  function initialize(root = document) {
    root.querySelectorAll('[data-cm-phone-reveal]').forEach(button => {
      if (button.dataset.revealReady) return;
      button.dataset.revealReady = 'true';
      const phone = button.querySelector('.cm-feature-phone');
      const label = button.getAttribute('aria-label').replace('Show full screen: ', '');
      const close = () => {
        if (modalSource === button && dialog?.open) { dialog.close(); return; }
        button.setAttribute('aria-expanded', 'false');
        button.setAttribute('aria-label', `Show full screen: ${label}`);
      };
      const open = () => {
        document.querySelectorAll('[data-cm-phone-reveal][aria-expanded="true"]').forEach(other => { if (other !== button) other.dispatchEvent(new Event('cm:phone-close')); });
        if (isMobile()) {
          const modal = getDialog();
          if (modal.open) return;
          const clone = phone.cloneNode(true);
          clone.querySelectorAll('img').forEach(image => image.loading = 'eager');
          modal.querySelector('.cm-phone-dialog-content').replaceChildren(clone);
          modal.setAttribute('aria-label', label);
          modalSource = button; modalClose = close;
          previousOverflow = document.body.style.overflow;
          document.body.style.overflow = 'hidden';
          modal.showModal();
        } else {
          const scale = Math.min(1.5, 330 / phone.offsetWidth, window.innerHeight * .76 / phone.offsetHeight);
          const rect = button.getBoundingClientRect();
          const desiredTop = Math.max(105, rect.bottom - phone.offsetHeight * scale);
          button.style.setProperty('--cm-phone-shift', `${desiredTop - rect.top - phone.offsetHeight * (1 - scale)}px`);
          button.style.setProperty('--cm-phone-scale', scale);
        }
        button.setAttribute('aria-expanded', 'true');
        button.setAttribute('aria-label', `Close full screen: ${label}`);
      };
      button.addEventListener('cm:phone-close', close);
      button.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse' && !isMobile()) open(); });
      button.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse' && !isMobile()) close(); });
      button.addEventListener('click', event => {
        if (event.pointerType === 'mouse' && !isMobile()) { open(); return; }
        button.getAttribute('aria-expanded') === 'true' ? close() : open();
      });
      document.addEventListener('pointerdown', event => { if (modalSource !== button && !button.contains(event.target)) close(); });
      button.addEventListener('keydown', event => { if (event.key === 'Escape') { close(); event.preventDefault(); } });
      button.addEventListener('focusout', () => { if (modalSource !== button) close(); });
      window.addEventListener('resize', close);
    });
  }
  initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
